import React from "react";
import styled from "styled-components";
import PageWrapper from "../components/PageWrapper";
import ProtectedRoute from "../components/ProtectedRoute";
import Seo from "../components/Seo";
import Markdown from "../components/Markdown/Markdown";
import { ONBOARDING_GUIDE } from "../data/onboarding-guide";

const Wrap = styled.section`
  padding: 96px 0 128px;
  background: var(--nd-black);
  color: var(--nd-text-display);
  min-height: 60vh;
`;

const Container = styled.div`
  max-width: 720px;
  margin: 0 auto;
  padding: 0 24px;
`;

const Kicker = styled.p`
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--nd-text-disabled);
  margin: 0 0 12px;
`;

const Title = styled.h1`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 36px;
  font-weight: 500;
  letter-spacing: -0.02em;
  color: var(--nd-text-display);
  margin: 0 0 40px;
  line-height: 1.1;

  @media (max-width: 600px) {
    font-size: 26px;
  }
`;

const GuidePage = () => (
  <>
    <Seo
      title="Onboarding Guide — Dioscuro"
      description="Study-setup guide for new junior DevOps engineers joining the Dioscuro Academy."
      pathname="/guide"
    />
    <PageWrapper>
      <ProtectedRoute requiredRole="public">
        <Wrap>
          <Container>
            <Kicker>ACADEMY · GETTING STARTED</Kicker>
            <Title>Your first-day setup guide</Title>
            <Markdown source={ONBOARDING_GUIDE} />
          </Container>
        </Wrap>
      </ProtectedRoute>
    </PageWrapper>
  </>
);

export default GuidePage;
